module.exports = __webpack_public_path__ + "img/plus-green-indicator.782a90cf.svg";